export interface ICultures {
  'nl-BE': string;
  'nl-NL': string;
  'fr-BE': string;
  'fr-FR': string;
  'en-US': string;
  'en-GB': string;
}

export const cultures: ICultures = {
  'nl-BE': 'Nederlands (België)',
  'nl-NL': 'Nederlands (Nederland)',
  'fr-BE': 'Français (Belgique)',
  'fr-FR': 'Français (France)',
  'en-US': 'English (United States)',
  'en-GB': 'English (Great Britain)',
};
